import React from 'react';
import type { LucideIcon } from 'lucide-react';

export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type IconVariant = 'default' | 'active' | 'success' | 'warning' | 'error';

export interface IconProps {
  icon: LucideIcon;
  size?: IconSize;
  variant?: IconVariant;
  filled?: boolean;
  className?: string;
}

export function Icon({
  icon: LucideComponent,
  size = 'md',
  variant = 'default',
  filled = false,
  className
}: IconProps): React.JSX.Element {
  const sizeMap: Record<IconSize, number> = {
    xs: 14,
    sm: 18,
    md: 22,
    lg: 28,
    xl: 48
  };

  const strokeMap: Record<IconSize, number> = {
    xs: 2,
    sm: 1.75,
    md: 1.5,
    lg: 1.5,
    xl: 1.25
  };

  const variantClasses: Record<IconVariant, string> = {
    default: 'text-[var(--icon-default)]',
    active: 'text-[var(--icon-active)]',
    success: 'text-[var(--status-success)]',
    warning: 'text-[var(--status-warning)]',
    error: 'text-[var(--status-error)]'
  };

  return (
    <LucideComponent
      size={sizeMap[size]}
      strokeWidth={strokeMap[size]}
      fill={filled ? 'currentColor' : 'none'}
      className={`transition-colors duration-200 ${variantClasses[variant]} ${className ?? ''}`}
    />
  );
}
